



// import React, { useState } from "react";
// import {
//   Box,
//   Button,
//   Grid,
//   Typography,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Paper,
//   Alert,
// } from "@mui/material";
// import { styled } from "@mui/material/styles";
// import CloudUploadIcon from "@mui/icons-material/CloudUpload";
// import GetAppIcon from "@mui/icons-material/GetApp";
// import CancelIcon from "@mui/icons-material/Cancel";
// import * as XLSX from "xlsx";
// import Swal from "sweetalert2";
// import { useNavigate } from "react-router-dom";
// import { ProductBulckUpload } from "../../../../services/api/product";

// const VisuallyHiddenInput = styled("input")({
//   clip: "rect(0 0 0 0)",
//   clipPath: "inset(50%)",
//   height: 1,
//   overflow: "hidden",
//   position: "absolute",
//   bottom: 0,
//   left: 0,
//   whiteSpace: "nowrap",
//   width: 1,
// });

// const BulkUploadVendor = () => {
//   const [excelFile, setExcelFile] = useState(null);
//   const [typeError, setTypeError] = useState(null);
//   const [excelData, setExcelData] = useState(null);
//   const [loading, setLoading] = useState(false);
//   const navigate = useNavigate();
//   const subdomain = localStorage.getItem("vendorsubdomain");

//   const handleFile = (e) => {
//     e.preventDefault();
//     const fileTypes = [
//       "application/vnd.ms-excel",
//       "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
//       "text/csv",
//     ];
//     const selectedFile = e.target.files[0];
//     if (selectedFile) {
//       if (fileTypes.includes(selectedFile?.type)) {
//         setTypeError(null);
//         const reader = new FileReader();
//         reader.readAsArrayBuffer(selectedFile);
//         reader.onload = (e) => setExcelFile(e.target.result);
//       } else {
//         setTypeError("Please select a valid Excel file.");
//         setExcelFile(null);
//       }
//     }
//   };

//   const handleFileSubmit = (e) => {
//     e.preventDefault();
//     if (excelFile) {
//       const workbook = XLSX.read(excelFile, { type: "buffer" });
//       const worksheetName = workbook?.SheetNames[0];
//       const worksheet = workbook?.Sheets[worksheetName];
//       const data = XLSX.utils.sheet_to_json(worksheet);
//       setExcelData(data);
//     }
//   };

//   const uploadFile = async () => {
//     if (excelData && Object.keys(excelData).length > 0) {
//       const payload = { products: excelData };
//       setLoading(true);
//       try {
//         const response = await ProductBulckUpload(subdomain, payload);
// console.log(response,"response")
//         if (response.success) {

//           setLoading(false);
//           Swal.fire({
//             icon: "success",
//             title: "Product Successfully Uploaded",
//             text: response.data.message,
//             timer: 3000,
//             showConfirmButton: true,
//           });
//           navigate(`/${subdomain}/products`);
//         } else {
//           setLoading(false);
//           Swal.fire({
//             icon: "error",
//             // title: "Product Successfully Uploaded",
//             text: response.data.message,
//             timer: 3000,
//             showConfirmButton: true,
//           });

//         }
//       } catch (error) {
//         console.log(error,"error:")
//         setLoading(false);
//         Swal.fire({
//           icon: "error",
//           title: "Oops...",
//           text: error?.response?.data?.message || "Something went wrong",
//           timer: 4000,
//           showConfirmButton: true,
//         });
//       }
//     }
//   };

//   const handleCancel = () => {
//     setExcelFile(null);
//     setExcelData(null);
//     setTypeError(null);
//     document.getElementById("fileInput").value = null;
//   };

//   return (
//     <Box sx={{ p: 4 }}>
//       <Typography variant="h5" gutterBottom>
//         Bulk Upload & View
//       </Typography>

//       <form onSubmit={handleFileSubmit}>
//         <Grid container spacing={2} alignItems="center">
//           <Grid item xs={12} md={6}>
//             <input
//               type="file"
//               id="fileInput"
//               required
//               onChange={handleFile}
//               className="form-control"
//               style={{
//                 border: "1px solid #ccc",
//                 borderRadius: "4px",
//                 padding: "8px",
//                 width: "100%",
//               }}
//             />
//           </Grid>

//           <Grid item>
//             <Button type="submit" variant="contained">
//               View File
//             </Button>
//           </Grid>

//           <Grid item>
//             <Button
//               variant="contained"
//               color="success"
//               onClick={uploadFile}
//               startIcon={<CloudUploadIcon />}
//               disabled={!excelData || loading}
//             >
//               {loading ? "Uploading..." : "Upload File"}
//             </Button>
//           </Grid>

//           <Grid item>
//             <Button
//               variant="contained"
//               color="primary"
//               startIcon={<GetAppIcon />}
//               href="/demo-file.xlsx"
//               download="demo-file.xlsx"
//             >
//               Demo File
//             </Button>
//           </Grid>

//           {excelFile && (
//             <Grid item>
//               <Button
//                 variant="contained"
//                 color="error"
//                 startIcon={<CancelIcon />}
//                 onClick={handleCancel}
//               >
//                 Cancel
//               </Button>
//             </Grid>
//           )}
//         </Grid>

//         {typeError && (
//           <Box mt={2}>
//             <Alert severity="error">{typeError}</Alert>
//           </Box>
//         )}
//       </form>

//       <Box mt={4}>
//         {excelData ? (
//           <TableContainer component={Paper}>
//             <Table>
//               <TableHead>
//                 <TableRow>
//                   {Object.keys(excelData[0]).map((key, idx) => (
//                     <TableCell key={idx} sx={{ fontWeight: "bold" }}>
//                       {key}
//                     </TableCell>
//                   ))}
//                 </TableRow>
//               </TableHead>
//               <TableBody>
//                 {excelData.map((row, rowIndex) => (
//                   <TableRow key={rowIndex}>
//                     {Object.keys(row).map((cell, i) => (
//                       <TableCell key={i} align="center">
//                         {row[cell]}
//                       </TableCell>
//                     ))}
//                   </TableRow>
//                 ))}
//               </TableBody>
//             </Table>
//           </TableContainer>
//         ) : (
//           <Typography
//             mt={2}
//             sx={{
//               color: "red",
//               fontWeight: "bold",
//               textTransform: "uppercase",
//             }}
//           >
//             No file uploaded. Only 50 products can be uploaded per Excel file.
//           </Typography>
//         )}
//       </Box>
//     </Box>
//   );
// };

// export default BulkUploadVendor;


import React, { useState } from "react";
import {
  Box,
  Button,
  Grid,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Alert,
  Snackbar,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import GetAppIcon from "@mui/icons-material/GetApp";
import CancelIcon from "@mui/icons-material/Cancel";
import * as XLSX from "xlsx";
import { useNavigate } from "react-router-dom";
import { ProductBulckUpload } from "../../../../services/api/product";

const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
});

const BulkUploadVendor = () => {
  const [excelFile, setExcelFile] = useState(null);
  const [typeError, setTypeError] = useState(null);
  const [excelData, setExcelData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  const navigate = useNavigate();
  const subdomain = localStorage.getItem("vendorsubdomain");

  const handleFile = (e) => {
    e.preventDefault();
    const fileTypes = [
      "application/vnd.ms-excel",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      "text/csv",
    ];
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      if (fileTypes.includes(selectedFile?.type)) {
        setTypeError(null);
        const reader = new FileReader();
        reader.readAsArrayBuffer(selectedFile);
        reader.onload = (e) => setExcelFile(e.target.result);
      } else {
        setTypeError("Please select a valid Excel file.");
        setExcelFile(null);
      }
    }
  };

  const handleFileSubmit = (e) => {
    e.preventDefault();
    if (excelFile) {
      const workbook = XLSX.read(excelFile, { type: "buffer" });
      const worksheetName = workbook?.SheetNames[0];
      const worksheet = workbook?.Sheets[worksheetName];
      const data = XLSX.utils.sheet_to_json(worksheet);
      setExcelData(data);
    }
  };

  const uploadFile = async () => {
    if (excelData && Object.keys(excelData).length > 0) {
      const payload = { products: excelData };
      setLoading(true);
      try {
        const response = await ProductBulckUpload(subdomain, payload);
        console.log(response,"response")
        if (response.success) {
          setSnackbar({
            open: true,
            message: response.data.message || "Products uploaded successfully.",
            severity: "success",
          });
          setTimeout(() => navigate(`/${subdomain}/products`), 3000);
        } else {
          setSnackbar({
            open: true,
            message: response?.data?.message || "Upload failed.",
            severity: "error",
          });
        }
      } catch (error) {
        setSnackbar({
          open: true,
          message: error?.response?.data?.message || "Something went wrong",
          severity: "error",
        });
      } finally {
        setLoading(false);
      }
    }
  };

  const handleCancel = () => {
    setExcelFile(null);
    setExcelData(null);
    setTypeError(null);
    document.getElementById("fileInput").value = null;
  };

  const handleCloseSnackbar = () => {
    setSnackbar((prev) => ({ ...prev, open: false }));
  };

  return (
    <Box sx={{ p: 4 }}>
      <Typography variant="h5" gutterBottom>
        Bulk Upload & View
      </Typography>

      <form onSubmit={handleFileSubmit}>
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12} md={6}>
            <input
              type="file"
              id="fileInput"
              required
              onChange={handleFile}
              className="form-control"
              style={{
                border: "1px solid #ccc",
                borderRadius: "4px",
                padding: "8px",
                width: "100%",
              }}
            />
          </Grid>

          <Grid item>
            <Button type="submit" variant="contained">
              View File
            </Button>
          </Grid>

          <Grid item>
            <Button
              variant="contained"
              color="success"
              onClick={uploadFile}
              startIcon={<CloudUploadIcon />}
              disabled={!excelData || loading}
            >
              {loading ? "Uploading..." : "Upload File"}
            </Button>
          </Grid>

          <Grid item>
            <Button
              variant="contained"
              color="primary"
              startIcon={<GetAppIcon />}
              href="/demo-file.xlsx"
              download="demo-file.xlsx"
            >
              Demo File
            </Button>
          </Grid>

          {excelFile && (
            <Grid item>
              <Button
                variant="contained"
                color="error"
                startIcon={<CancelIcon />}
                onClick={handleCancel}
              >
                Cancel
              </Button>
            </Grid>
          )}
        </Grid>

        {typeError && (
          <Box mt={2}>
            <Alert severity="error">{typeError}</Alert>
          </Box>
        )}
      </form>

      <Box mt={4}>
        {excelData ? (
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  {Object.keys(excelData[0]).map((key, idx) => (
                    <TableCell key={idx} sx={{ fontWeight: "bold" }}>
                      {key}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {excelData.map((row, rowIndex) => (
                  <TableRow key={rowIndex}>
                    {Object.keys(row).map((cell, i) => (
                      <TableCell key={i} align="center">
                        {row[cell]}
                      </TableCell>
                    ))}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        ) : (
          <Typography
            mt={2}
            sx={{
              color: "red",
              fontWeight: "bold",
              textTransform: "uppercase",
            }}
          >
            No file uploaded. Only 50 products can be uploaded per Excel file.
          </Typography>
        )}
      </Box>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={4000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity={snackbar.severity}
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default BulkUploadVendor;
